var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": "",
      "flat-chrome": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "bank-account-grid"
  }, [!_vm.params.bankOnly ? _c('v-select', {
    attrs: {
      "items": _vm.accountKinds,
      "label": _vm.$translate('accountKind'),
      "hide-details": "auto",
      "error-messages": _vm.fieldErrors.kind,
      "outlined": "",
      "dense": "",
      "disabled": _vm.saving
    },
    on: {
      "change": _vm.focusBankName
    },
    model: {
      value: _vm.form.kind,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kind", $$v);
      },
      expression: "form.kind"
    }
  }) : _vm._e(), _vm.form.kind === 'bank' ? _c('v-text-field', {
    ref: "bankName",
    attrs: {
      "autofocus": "",
      "value": _vm.form.bank_name,
      "label": _vm.$translate('labels.bankName'),
      "error-messages": _vm.fieldErrors.bank_name,
      "maxlength": "140",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.saving
    },
    on: {
      "input": _vm.updateBankName
    }
  }) : _vm._e(), _c('v-text-field', {
    staticClass: "bank-account-name",
    attrs: {
      "label": _vm.$translate('labels.label'),
      "error-messages": _vm.fieldErrors.label,
      "maxlength": "80",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autofocus": _vm.form.kind !== 'bank',
      "disabled": _vm.saving
    },
    model: {
      value: _vm.form.label,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "label", $$v);
      },
      expression: "form.label"
    }
  }), ['bank', 'provider'].includes(_vm.form.kind) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$translate('labels.accountHolder'),
      "error-messages": _vm.fieldErrors.account_holder,
      "maxlength": "140",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "required": "",
      "disabled": _vm.saving
    },
    on: {
      "input": function input($event) {
        _vm.holderEdited = true;
      }
    },
    model: {
      value: _vm.form.account_holder,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "account_holder", $$v);
      },
      expression: "form.account_holder"
    }
  }) : _vm._e(), _vm.form.kind === 'bank' ? _c('v-text-field', {
    attrs: {
      "label": _vm.$translate('labels.iban'),
      "error-messages": _vm.fieldErrors.iban,
      "maxlength": "42",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.saving
    },
    model: {
      value: _vm.form.iban,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "iban", $$v);
      },
      expression: "form.iban"
    }
  }) : _vm._e(), _vm.form.kind === 'bank' ? _c('v-text-field', {
    attrs: {
      "label": _vm.$translate('labels.bic'),
      "error-messages": _vm.fieldErrors.bic,
      "maxlength": "11",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.saving
    },
    model: {
      value: _vm.form.bic,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bic", $$v);
      },
      expression: "form.bic"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "label": _vm.$translate('labels.accountingCode'),
      "error-messages": _vm.fieldErrors.accounting_code,
      "maxlength": "20",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.saving
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate('labels.accountingCode')))]), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('accountingCodeHelp')
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.accounting_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "accounting_code", $$v);
      },
      expression: "form.accounting_code"
    }
  })], 1), _vm.form.kind === 'bank' ? _c('div', {
    staticClass: "mt-5"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.$translate('labels.default'),
      "disabled": _vm.defaultLocked,
      "error-messages": _vm.fieldErrors.is_default,
      "dense": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.is_default,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_default", $$v);
      },
      expression: "form.is_default"
    }
  })], 1) : _vm._e()]), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "ghost": "",
      "disabled": _vm.saving,
      "text": _vm.$translate('buttons.cancel')
    },
    on: {
      "click": function click($event) {
        return _vm.hideModal();
      }
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "disabled": _vm.saving,
      "loading": _vm.saving,
      "text": _vm.$translate('buttons.save')
    },
    on: {
      "click": _vm.save
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }